import {AfterViewInit, Component, OnInit, ViewChild, ViewContainerRef, ViewEncapsulation} from '@angular/core';
import {TrnAdmissionService} from '../../configuration/trn-admission/trn-admission.service';
import {Observable} from 'rxjs/Observable';
import {PaginationInstance} from 'ngx-pagination';
import {OpdPatientConfigService} from '../../configuration/application-configuration/opd-patient-config/opd-patient-config.service';
import {DischargeService} from '../discharge/discharge.service';
import {DischargeSummaryService} from '../discharge-summary/discharge-summary.service';
import {ConfirmationService} from 'primeng/primeng';
import {MipdBedService} from '../../configuration/mipd-bed/mipd-bed.service';
import {TrnBedStatusService} from '../../configuration/trn-bed-status/trn-bed-status.service';
import {MstClassService} from '../../configuration/mst-class/mst-class.service';
import {MipdWardService} from '../../configuration/mipd-ward/mipd-ward.service';
import {MipdRoomService} from '../../configuration/mipd-room/mipd-room.service';
import {TbillBillService} from '../../billing/tbill-bill/tbill-bill.service';
import {BedTransferService} from '../bed-management/bed-transfer/bed-transfer.service';
import {DaterangepickerConfig} from 'ng2-daterangepicker';
import {DatepickerConfig} from '../../shared/custom-service/datepicker-configuration.service';
import {MstVisitService} from '../../configuration/mst-visit/mst-visit.service';
import {ToastsManager} from 'ng2-toastr';
import {Router} from '@angular/router';
import {MstStaffService} from '../../configuration/mst-staff/mst-staff.service';
import {TemrTimelineService} from '../../configuration/temr-timeline/temr-timeline.service';
import {CpoeInvestigationService} from '../../patient-chart/patient-chart-parent/patient-emr/emr-cpoe/cpoe-investigation/cpoe-investigation.service';
import {DischargeSummaryNewService} from '../discharge-summary-new/discharge-summary-new.service';
import {MstSectionService} from '../../configuration/mst-section/mst-section.service';
import {MstFieldService} from '../../configuration/mst-field/mst-field.service';
import {MstSetService} from '../../configuration/mst-set/mst-set.service';
import {MstTabService} from '../../configuration/mst-tab/mst-tab.service';
import {MstDischargeSummaryFormService} from '../../configuration/mst-discharge-summary-form/mst-discharge-summary-form.service';
import {Shatabdi2, swaraj, viewstaffsignature,CONSTSHIVAMHOSPITAL} from '../../shared/my-constants';
import {MipdDischargeTypeService} from '../../configuration/mipd-discharge-type/mipd-discharge-type.service';
import {ApiRequestService} from '../../shared/api-request-service';
import {TrnSponsorCombinationService} from '../../configuration/trn-sponsor-combination/trn-sponsor-combination.service';

declare var $: any;

@Component({
    selector: 'app-trn-dischargelist',
    templateUrl: './trn-dischargelist.component.html',
    styleUrls: ['./trn-dischargelist.component.css'],
    encapsulation: ViewEncapsulation.None,
})
export class TrnDischargelistComponent implements OnInit, AfterViewInit {
    isCashPatient: boolean = true;

    fromdate: any;
    todate: any;
    todaylist: any;
    public options: any;
    datePickerConfig: any;
    currentdatesmartcard: any;
    lastvisitdetails: any = {};
    trnDischargeList: Observable<any[]>;
    swaraj: Boolean = swaraj;
    search_query: any = {};
    public strtdate: any = null;
    public enddate: any = null;
    trnAdmissionList: Observable<any[]>;
    loading: boolean;
    public config: PaginationInstance = {
        id: 'advanced',
        itemsPerPage: 10,
        currentPage: 1,
        totalItems: 1
    };
    selectedTrnAdmission: any = {};
    patientcompanydetails: Array<any>;
    isCompanyInfo: boolean;
    admissionform = false;
    selectedadmissionform: any = {};
    selecteddischargepatient: any = {};
    dischargeformdate: any = {};
    dischargesummaryformdate: Array<any> = [];
    // for search
    qString: any = '';
    type: any;
    dischargeform = false;
    dischargeformPrint = false;
    dischargesummaryform = false;
    unitinfo: any = {};
    followupdate: any;
    dischargeStaffId: any;
    dischargedate: any;
    dischaergeStaffName: any;
    dischaergeStaffEducation: any;
    dischargecancelpop = false;
    selectedpatientdata: any;
    mipdWardList: Array<any> = [];
    mipdBedList: Array<any> = [];
    mipdRoomList: Array<any> = [];
    unitID: any;
    mstClassList: Array<any> = [];
    afterdischargebed: any;
    newbedselected: any;
    dischargecancelbut: any;
    currentuserdetails: any = {};
    mstStaffList: Array<any> = [];
    admissionObj: any = {};
    displayStaffList: any = false;
    lastPatientEposide: any = {};
    unitid: any;
    mstStaff: any = {};
    selectedstaffId: any;
    selectedStaffService: Array<any> = [];
    service: any = 0;
    applyChargesInBill: Boolean = false;
    shatabdi: boolean = Shatabdi2;
    createdTimelineId: any;
    temrVisitInvestigation: any = {};
    newPatientEposideCreated: any = {};
    admissionFieldList: Array<any> = [];
    selectedFormSecPrevList: Array<any> = [];
    selectedFormTabPrevList: Array<any> = [];
    selectedFormSetPrevList: Array<any> = [];
    dischargeDoctor: any = '';
    // usersign_url = base_path.usersign;
    usersign_url = viewstaffsignature;
    userAccess: Array<any> = [];
    smbCancelDischarge: boolean;
    mipdDischargeTypeList: Array<any> = [];
    @ViewChild('wordid') selectWard;
    @ViewChild('roomid') selectRoom;
    editDischargeSummaryButton = false;
    CONSTSHIVAMHOSPITAL: Boolean = CONSTSHIVAMHOSPITAL;

    constructor(private trnAdmissionService: TrnAdmissionService,
                private trnSponsorCombinationService: TrnSponsorCombinationService,
                private application: OpdPatientConfigService,
                private dischargeService: DischargeService,
                private confirmationService: ConfirmationService,
                private dischargesummary: DischargeSummaryService,
                private mstClassService: MstClassService,
                private mipdWardService: MipdWardService,
                private mipdBedService: MipdBedService,
                private mipdRoomService: MipdRoomService,
                private tbillBillService: TbillBillService,
                private trnBedStatusService: TrnBedStatusService,
                private mipdDischargeTypeService: MipdDischargeTypeService,
                private BedTransferService: BedTransferService,
                private daterangepickerOptions: DaterangepickerConfig,
                private mstVisitService: MstVisitService,
                public toastr: ToastsManager,
                private router: Router,
                private mstStaffService: MstStaffService,
                private temrTimelineService: TemrTimelineService,
                private cpoeInvestigationService: CpoeInvestigationService,
                private mstDischargeSummaryNewService: DischargeSummaryNewService,
                private mstSectionService: MstSectionService,
                private mstFieldService: MstFieldService,
                private mstSetService: MstSetService,
                private mstTabService: MstTabService,
                private apiRequestService: ApiRequestService,
                private mstDischargeSummaryFormService: MstDischargeSummaryFormService,
                vcr: ViewContainerRef) {
        this.currentuserdetails = JSON.parse(sessionStorage.getItem('userdetail'));
        this.datePickerConfig = DatepickerConfig;
        this.toastr.setRootViewContainerRef(vcr);
        this.gettodaysdate();
        this.options = {
            locale: {format: 'DD-MM-YYYY'},
            alwaysShowCalendars: false,
            singleDatePicker: true,
            showDropdowns: true,
            minDate: this.currentdatesmartcard
        };
        this.daterangepickerOptions.settings = {
            locale: {format: 'YYYY-MM-DD'},
            alwaysShowCalendars: false,
            singleDatePicker: true,
            showDropdowns: true,
            autoUpdateInput: false
        };
        this.fromdate = '';
        this.todate = '';
        this.todaylist = false;
    }

    ngOnInit() {
        this.dischargecancelbut = false;
        this.type = 0;
        this.userAccess = JSON.parse(sessionStorage.getItem('useraction'));
        const module = obj => obj.aurActionModuleName === 'IPD';
        const subModule = obj => obj.aurActionSubModuleName === 'Discharge Summary';
        const actionBtn = obj => obj.abName === 'editDischargeSummaryBtn';
        const submoduleIndex = this.userAccess.findIndex(subModule);
        // const actionBtnIndex = this.userAccess.findIndex(actionBtn);
        const btnIndex = (this.userAccess[submoduleIndex].actionButton).findIndex(actionBtn);
        if (btnIndex !== -1) {
            this.editDischargeSummaryButton = true;
        }


        this.loadUserSubModule();
        this.followupdate = '';
        this.dischargeStaffId = '';
        this.unitID = JSON.parse(sessionStorage.getItem('unitId'));
        this.getStaffList();
        this.getPage(1);
        this.application.getRecordByUnitId(sessionStorage.getItem('unitId')).then(resp => {
            this.unitinfo = resp.configUnitId;
        });
        this.mstClassService.getAllRecordService('', '', '', '', '').then(resp => this.mstClassList = resp.content);
        this.mipdDischargeTypeService.getAllRecordService(1, '', '', '', '')
            .then(resp => {
                this.mipdDischargeTypeList = resp.content;
            });
        this.mipdWardService.getAllRecordbyunitService(this.unitID).then(resp => {
            console.log(resp);
            this.mipdWardList = resp;
        });
    }

    ngAfterViewInit() {
        this.getPage(1);
    }

    gettodaysdate() {
        let dd: any;
        let mm: any;
        let today: any;
        today = new Date();
        dd = today.getDate();
        mm = today.getMonth() + 1;
        let yyyy = today.getFullYear();
        if (dd < 10) {
            dd = '0' + dd;
        }
        if (mm < 10) {
            mm = '0' + mm;
        }
        today = dd + '/' + mm + '/' + yyyy;
        this.currentdatesmartcard = today;
    }

    selectedclass(classID: any) {
        console.log(classID);
        this.mipdWardService.getAllRecordbyunitancclassService(classID, this.unitID).then(resp => {
            console.log(resp);
            this.mipdWardList = resp;
        });
    }

    onchangeword(wordid: any) {
        this.mipdRoomService.getWardByRoomIdService(wordid).then(resp => {
            this.mipdRoomList = resp;
            this.trnBedStatusService.getFreeBedListbyword(wordid).then(resp => {
                if (this.mipdBedList.length > 0) {
                    this.mipdBedList = resp;
                } else {
                    this.mipdBedList = resp;
                }
            });
        });
    }

    onchangeroom(roomid: any) {
        this.trnBedStatusService.getFreeBedListbyroomId(roomid).then(resp => {
            if (this.mipdBedList.length > 0) {
                this.mipdBedList = resp;
            } else {
                this.mipdBedList = resp;
                this.toastr.warning('Please Select Bed  ', 'Alert!');
            }
        });
    }

    getPage(page: number) {
        this.loading = true;
        this.trnAdmissionService.getAllDischargeRecordService(page, this.config.itemsPerPage, this.qString, '', '', this.type)
            .then(resp => {
                console.log(resp);
                this.config.currentPage = page;
                this.config.totalItems = resp.totalElements;
                this.loading = false;
                this.trnAdmissionList = resp.content;
            });
    }

    searchfilter(name: any, typeselected: any) {
        this.type = typeselected;
        this.qString = name;
        this.getPage(1);
    }

    searchfilterByDate(startDate: any, enddate: any, event: any) {
        let today = event.target.checked;
        console.log('today', today);
        this.trnAdmissionService.getAllDischargeRecordServicefilter(today, startDate, enddate, this.unitID, this.config.currentPage, this.config.itemsPerPage)
            .then(resp => {
                console.log(resp);
                this.config.currentPage = 1;
                this.config.totalItems = resp.totalElements;
                this.loading = false;
                this.trnAdmissionList = resp.content;
            });
    }

    getdischarge(admission: any) {
        console.log(admission);
        this.selecteddischargepatient = admission;
        this.dischargeService.getRecordServicebyadmissionid(admission.admissionId).then(resp => {
            console.log(resp);
            this.dischargeformdate = resp;
        });
        this.dischargeform = true;
    }

    modifyDischargeSummary(admission: any) {
        this.router.navigate(['/ipd/dischargesummarynew', admission.admissionId]);
    }

    // pagination methods
    onRecordCountChange(records: number) {
        this.config.itemsPerPage = records;
        this.getPage(this.config.currentPage);
    }

    onCancel() {
        this.dischargeform = false;
    }

    onCancel1() {
        this.selectedadmissionform = '';
        this.admissionform = false;
    }

    getdischargesummary(admission: any) {
        console.log(admission);
        this.selecteddischargepatient = admission;
        this.dischargesummary.getrecordservice(admission.admissionId).then(resp => {
            console.log(resp);
            if (resp != null && resp != '') {
                this.dischargesummaryform = true;
            }
            else {
                alert('Plesae Fill Discharge Summary');
            }
            this.dischargesummaryformdate = resp;

            this.dischargesummaryformdate = this.dischargesummaryformdate.sort((a, b) => {
                console.log('a.dsnFieldId.sequence => ' + a.dsnFieldId.sequence);
                if (Number(a.dsnFieldId.sequence) < Number(b.dsnFieldId.sequence)) {
                    return -1;
                } else if (Number(a.dsnFieldId.sequence) > Number(b.dsnFieldId.sequence)) {
                    return 1;
                } else {
                    return 0;
                }
            });

            this.followupdate = resp[0].followupDate;
            this.dischargeStaffId = resp[0].dischargeStaffId.staffUserId.userFullname;
            console.log('this.dischargeStaffId');
            console.log(this.dischargeStaffId);
            this.dischargedate = resp[0].createdDate;
        });
    }

    dischargeAdmissionId: any;

    getdischargesummarynew(admission: any, trnDischarge: any) {
        console.log('admission', admission);
        console.log('trnDischarge', trnDischarge);
        this.selecteddischargepatient = admission;
        this.dischargeAdmissionId = admission.admissionId;
        this.selectedTrnAdmission = trnDischarge;
        console.log('this.selectedTrnAdmission');
        console.log(this.selectedTrnAdmission);
        this.dischargeService.getRecordServicebyadmissionid(admission.admissionId).then(resp => {
            this.dischargedate = resp.dischargeDate;

            this.dischaergeStaffName = resp.dischargeStaffId.staffUserId.userFullname;
            this.dischaergeStaffEducation = resp.dischargeStaffId.staffEducation;
            console.log('this.dischaergeStaffName');
            console.log(this.dischaergeStaffName);
        });
        this.mstDischargeSummaryNewService.getrecordservice(admission.admissionId).then(mstDischargesummaryNew => {
            console.log('mstDischargesummaryNewsssss', mstDischargesummaryNew);
            this.admissionFieldList = mstDischargesummaryNew;

            this.admissionFieldList = this.admissionFieldList.sort((a, b) => {
                console.log('a.dsnFieldId.sequence => ' + a.dsnFieldId.sequence);
                if (Number(a.dsnFieldId.sequence) < Number(b.dsnFieldId.sequence)) {
                    return -1;
                } else if (Number(a.dsnFieldId.sequence) > Number(b.dsnFieldId.sequence)) {
                    return 1;
                } else {
                    return 0;
                }
            });

            if (mstDischargesummaryNew != null && mstDischargesummaryNew != '') {
                if (this.admissionFieldList.length > 0) {
                    this.followupdate = this.admissionFieldList[0].followupDate;
                }
                this.mstDischargeSummaryFormService.getRecordService(mstDischargesummaryNew[0].dsnDsfId.dsfId).then(formObj => {
                    // console.log('Seleted Form:  ', formObj);
                    this.mstSectionService.getRecordServiceByDsfId(formObj.dsfId).then(sectionList => {
                        this.selectedFormSecPrevList = sectionList;
                        // console.log('Seleted Form Section:  ', this.selectedFormSecPrevList);
                        for (let section of this.selectedFormSecPrevList) {
                            this.mstTabService.getTabListByDsfIdSectionId(formObj.dsfId, section.sectionId).then(tabList => {
                                for (let tab of tabList) {
                                    this.selectedFormTabPrevList = this.selectedFormTabPrevList.filter(it => it.tabId != tab.tabId);
                                    this.selectedFormTabPrevList.push(tab);
                                    // console.log('Seleted Form tabList:  ', this.selectedFormTabPrevList);
                                    this.mstSetService.getsetListByDsfIdSectionIdTabId(this.admissionFieldList[0].dsnDsfId.dsfId, section.sectionId, tab.tabId).then(setList => {
                                        for (let set of setList) {
                                            this.selectedFormSetPrevList.push(set);
                                            // console.log('Seleted Form selectedFormSetPrevList:  ', this.selectedFormSetPrevList);
                                        }
                                    });
                                }
                            });
                        }
                    });
                });
                this.dischargeformPrint = true;
            } else {
                // alert('Plesae Fill Discharge Summary');
                this.router.navigate(['/ipd/dischargesummarynew', admission.admissionId]);
            }
        });
    }

    getdischargesummarynewprint(admission: any, trnDischarge: any) {
        console.log('admission', admission);
        console.log('trnDischarge', trnDischarge);
        this.selecteddischargepatient = admission;
        this.dischargeAdmissionId = admission.admissionId;
        this.selectedTrnAdmission = trnDischarge;
        console.log('this.selectedTrnAdmission');
        console.log(this.selectedTrnAdmission);
        this.dischargeService.getRecordServicebyadmissionid(admission.admissionId).then(resp => {
            this.dischargedate = resp.dischargeDate;

            this.dischaergeStaffName = resp.dischargeStaffId.staffUserId.userFullname;
            this.dischaergeStaffEducation = resp.dischargeStaffId.staffEducation;
            console.log('this.dischaergeStaffName');
            console.log(this.dischaergeStaffName);
        });
        this.mstDischargeSummaryNewService.getrecordservice(admission.admissionId).then(mstDischargesummaryNew => {
            // console.log('mstDischargesummaryNew', mstDischargesummaryNew);
            this.admissionFieldList = mstDischargesummaryNew;

            this.admissionFieldList = this.admissionFieldList.sort((a, b) => {
                console.log('a.dsnFieldId.sequence => ' + a.dsnFieldId.sequence);
                if (Number(a.dsnFieldId.sequence) < Number(b.dsnFieldId.sequence)) {
                    return -1;
                } else if (Number(a.dsnFieldId.sequence) > Number(b.dsnFieldId.sequence)) {
                    return 1;
                } else {
                    return 0;
                }
            });

            if (mstDischargesummaryNew != null && mstDischargesummaryNew != '') {
                if (this.admissionFieldList.length > 0) {
                    this.followupdate = this.admissionFieldList[0].followupDate;
                }
                this.mstDischargeSummaryFormService.getRecordService(mstDischargesummaryNew[0].dsnDsfId.dsfId).then(formObj => {
                    // console.log('Seleted Form:  ', formObj);
                    this.mstSectionService.getRecordServiceByDsfId(formObj.dsfId).then(sectionList => {
                        this.selectedFormSecPrevList = sectionList;
                        // console.log('Seleted Form Section:  ', this.selectedFormSecPrevList);
                        for (let section of this.selectedFormSecPrevList) {
                            this.mstTabService.getTabListByDsfIdSectionId(formObj.dsfId, section.sectionId).then(tabList => {
                                for (let tab of tabList) {
                                    this.selectedFormTabPrevList = this.selectedFormTabPrevList.filter(it => it.tabId != tab.tabId);
                                    this.selectedFormTabPrevList.push(tab);
                                    // console.log('Seleted Form tabList:  ', this.selectedFormTabPrevList);
                                    this.mstSetService.getsetListByDsfIdSectionIdTabId(this.admissionFieldList[0].dsnDsfId.dsfId, section.sectionId, tab.tabId).then(setList => {
                                        for (let set of setList) {
                                            this.selectedFormSetPrevList.push(set);
                                            // console.log('Seleted Form selectedFormSetPrevList:  ', this.selectedFormSetPrevList);
                                        }
                                    });
                                }
                            });
                        }
                    });
                });
                this.dischargeformPrint = true;
            } else {
                // alert('Plesae Fill Discharge Summary');
                this.router.navigate(['/ipd/dischargesummarynew', admission.admissionId]);
            }
        });
    }

    editDisSummary(admission: any) {

        this.router.navigate(['/ipd/dischargesummarynew', admission.admissionId]);

        this.mstDischargeSummaryNewService.getrecordservice(admission.admissionId).then(mstDischargesummaryNew => {
            // console.log('mstDischargesummaryNew', mstDischargesummaryNew);
            this.admissionFieldList = mstDischargesummaryNew;


        });
    }

    patientbedselected(id: any, event) {
        this.newbedselected = id.bedId;
        $(document).ready(function () {
            $('.tootip').on('click', function () {
                $('.tootip').removeClass('bg-grey');
                $(this).addClass('bg-grey');
            });
        });
    }

    dischargecancelsave() {
        this.dischargecancelbut = true;
        let wardId = this.selectWard.nativeElement.value;
        if (this.newbedselected != '') {
            this.dischargecancelbut = true;
            this.confirmationService.confirm({
                message: 'Are you sure that you want to Cancel Discharge?',
                accept: () => {
                    console.log('selectedpatientdata ', this.selectedpatientdata);
                    this.trnBedStatusService.getFreeBedListbyword(wardId).then(resp => {
                        this.mipdBedList = resp;
                        let bed = this.mipdBedList.filter(bed => (bed.tbsBedId.bedId == this.newbedselected))[0];
                        if (bed != undefined) {
                            this.tbillBillService.finalbilltointermediate(this.selectedpatientdata.dischargeAdmissionId.admissionId).then(finalbill => {
                                if (finalbill) {
                                    this.trnAdmissionService.dischargeCancelService(this.selectedpatientdata.dischargeId, this.selectedpatientdata.dischargeAdmissionId.admissionId, this.newbedselected, this.currentuserdetails.staffUserId.userFullname).then(dischargeresp => {
                                        this.dischargecancelpop = false;
                                        this.dischargeDoctor = this.currentuserdetails.staffUserId.userFullname;
                                        console.log(this.dischargeDoctor);
                                        this.getPage(1);
                                        this.BedTransferService.autochargeinsert(this.selectedpatientdata.dischargeAdmissionId.admissionId, this.newbedselected).then(auto => {
                                            this.mipdBedList = [];
                                            this.selectedpatientdata = [];
                                            this.newbedselected = '';
                                        });
                                    });
                                }
                            });
                        } else {
                            // this.resetDetails();
                            this.onchangeroom(this.selectRoom.nativeElement.value);
                            this.toastr.warning('This Bed is already Occupied', 'Bed Details');
                            this.newbedselected = '';
                            this.dischargecancelbut = false;
                        }
                    });
                },
                reject: () => {
                    this.dischargecancelpop = false;
                    this.mipdBedList = [];
                }
            });
        } else {
            this.toastr.warning('Please select Bed');
            this.dischargecancelbut = false;
        }
    }

    // select start date search
    selectedStartDate(event: any) {
        // this.fromdate = event.start.format('YYYY-MM-DD');
        this.todaylist = false;
        // if (this.todate) {
        //   this.searchfilter('_', 7);
        // }
    }

    // select end date to search
    selectedEndDate(event: any) {
        //this.todate = event.start.format('YYYY-MM-DD');
        this.todaylist = false;
        if (this.fromdate) {
            this.searchfilterByDate(this.fromdate, this.todate, this.todaylist);
        }
    }

    confirmEMR(admissionObj: any) {
        console.log(admissionObj);
        this.admissionObj = admissionObj;
        this.confirmationService.confirm({
            message: 'Are you sure that you want create new episode?',
            header: 'Confirmation',
            icon: 'fa fa-question-circle',
            accept: () => {
                // const model: any = {};
                console.log(this.mstStaffList);
                this.displayStaffList = true;
            },
            reject: () => {
                this.mstVisitService.getLastEposideService(admissionObj.admissionPatientId.patientId, 1).then(resp => {
                    this.lastPatientEposide = resp;
                    // this.msgs = [{severity: 'info', summary: 'Rejected', detail: 'Continuing Last Eposide'}];
                    this.toastr.info('Continuing Last Episode', 'Rejected ! ');
                    console.log(this.lastPatientEposide);
                    this.router.navigate(['/patientchart/patient-chart-parent/', 'ipd', this.lastPatientEposide.visitId]);
                });
            }
        });
    }

    getStaffList() {
        this.mstStaffService.getAllDoctorByUnit(this.unitID).then(resp => {
            console.log('staff');
            this.mstStaffList = resp;
            console.log(this.mstStaffList);
        });
    }

    selectedStaff(staff: any) {
        this.mstStaffService.getRecordService(staff).then(resp => {
            console.log('staff');
            this.mstStaff = resp;
            console.log(this.mstStaff);
            this.selectedstaffId = staff;
            this.selectedStaffService = this.mstStaff.staffServiceId;
            console.log('services');
            console.log(this.mstStaff.staffServiceId);
            console.log(this.selectedStaffService);
        });
    }

    selectedService(serviceid: any) {
        this.service = serviceid;
    }

    setApplyChargesInBill(event: any) {
        this.applyChargesInBill = event.target.checked;
        console.log(event.target.checked);
    }

    submitStaff() {
        this.toastr.success('Staff Selected For This Episode', 'Success ! ');
        // console.log('Patient id');
        // console.log(this.admissionObj.admissionPatientId.patientId);
        this.temrTimelineService.createEposide(this.admissionObj.admissionPatientId.patientId, 1, this.selectedstaffId, this.service, this.admissionObj.admissionId).then(resp => {
            // console.log('Crewated timeline');
            // console.log(resp);
            this.createdTimelineId = resp.timelineId;
            if (this.applyChargesInBill === true) {
                this.temrVisitInvestigation.viServiceId = {serviceId: this.service};
                this.temrVisitInvestigation.viStaffId = {staffId: this.selectedstaffId};
                this.temrVisitInvestigation.viRegistrationSource = 1;
                this.temrVisitInvestigation.viCreatedDate = new Date();
                this.temrVisitInvestigation.viTimelineId = {timelineId: this.createdTimelineId};
                // console.log('temrVisitInvestigation');
                // console.log(this.temrVisitInvestigation);
                this.cpoeInvestigationService.addSericefromepisode(this.temrVisitInvestigation).then(resp => {
                    resp = resp;
                    // console.log('temrVisitInvestigation created ');
                    // console.log(resp);
                });
            }
            this.toastr.success('New Episode Created', 'Success ! ');
            this.mstVisitService.getVisitByPatientIdOfIpdPatient(this.admissionObj.admissionPatientId.patientId, 1)
                .then(resp => {
                    this.newPatientEposideCreated = resp;
                    // console.log(this.newPatientEposideCreated);
                    this.router.navigate(['/patientchart/patient-chart-parent/', 'ipd', this.newPatientEposideCreated.visitId]);
                });
        });
    }

    admissionFormDetail(admission: any) {
        this.isCashPatient = true;
        this.selectedadmissionform = admission;
        console.log('referBy ', this.selectedadmissionform);
        this.admissionform = true;
        this.mstVisitService.getrecordbypatientidlastvisit(admission.admissionPatientId.patientId).then(resp => {
            this.lastvisitdetails = resp;
            if (resp.visitTariffId.tariffId == 1) {
                this.isCashPatient = false;
                // this.isInsurancePatient = true;
            }
            // this.resetfilter();
            // console.log('LastVisit Deatisls',this.lastvisitdetails);
        });
        this.trnSponsorCombinationService.getAllRecordServicebyuser(admission.admissionPatientId.patientUserId.userId).then(sponcer => {
            this.patientcompanydetails = sponcer.record;
            if (this.patientcompanydetails.length == 0) {
                console.log('array 0');
                this.isCompanyInfo = false;
            } else {
                console.log('array1');
                this.isCompanyInfo = true;
            }
            console.log('Sponcer', sponcer);
        });
        // this.resetfilter();
    }

    dischargecancel(admission: any) {
        this.resetDetails();
        console.log('admission id ', admission);
        this.selectedpatientdata = admission;
        console.log('this.selectedpatientdata', this.selectedpatientdata);
        this.dischargecancelpop = true;
        this.dischargecancelbut = false;
    }

    resetDetails() {
        this.selectWard.nativeElement.value = 0;
        this.selectRoom.nativeElement.value = 0;
        this.mipdBedList = [];
        this.newbedselected = '';
    }

    onCancelDc() {
        this.dischargecancelpop = false;
        this.dischargecancelbut = false;
    }

    onCancelsummary() {
        this.dischargesummaryform = false;
    }

    print(printContents: any): void {
        if ($('body').hasClass('smart-rtl')) {
            let printContents, popupWin;
            printContents = document.getElementById('printContents').innerHTML;
            //printContents = document.getElementById(printSection).innerHTML;
            popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
            popupWin.document.open();
            popupWin.document.write(`
          <html>
              <head>
                  <title>Print tab</title>
                  <style>
                    body{
                    direction: rtl;
                    }
                    .no-border>tbody>tr>td{
                      border: none !important;
                    }
                    .printNone{
                      display: none !important;
                    }

                  </style>

                  <link rel="stylesheet" href="assets/css/your_style.css">

                  <!-- Latest compiled and minified CSS -->
                  <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css">

                  <!-- jQuery library -->
                  <script src="https://ajax.googleapis.com/ajax/libs/jquery/3.2.1/jquery.min.js"></script>

                  <!-- Latest compiled JavaScript -->
                  <script src="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/js/bootstrap.min.js"></script>

              </head>
              <body onload="window.print();window.close()">${printContents}
              </body>
          </html>`
            );
            popupWin.document.close();
        } else {
            let printContents, popupWin;
            printContents = document.getElementById('printContents').innerHTML;
            popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
            popupWin.document.open();
            popupWin.document.write(`
          <html>
              <head>
                  <title>Print tab</title>
                  <style>
                    .no-border>tbody>tr>td{
                      border: none !important;
                    }
                    .printNone{
                      display: none !important;
                    }

                  </style>

                  <link rel="stylesheet" href="assets/css/your_style.css">

                  <!-- Latest compiled and minified CSS -->
                  <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css">

                  <!-- jQuery library -->
                  <script src="https://ajax.googleapis.com/ajax/libs/jquery/3.2.1/jquery.min.js"></script>

                  <!-- Latest compiled JavaScript -->
                  <script src="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/js/bootstrap.min.js"></script>

              </head>
              <body onload="window.print();window.close()">${printContents}
              </body>
          </html>`
            );
            popupWin.document.close();
        }
    }

    printdischargeform(printContentssummary: any): void {
        let currentUser = JSON.parse(sessionStorage.getItem('userdetail'));
        let model = {
            'dssAdmissionId': {'admissionId': this.dischargeAdmissionId},
            'dssStaffId': {'staffId': currentUser.staffId},
            'dssStatus': 'View Summary Print',
        };
        this.apiRequestService.post('trn_discharge_summary_staff/create/', model).subscribe(resp => {
            console.log(resp);
        });

        if ($('body').hasClass('smart-rtl')) {
            let printContentssummary, popupWin;
            printContentssummary = document.getElementById('printContentssummaryNew').innerHTML;
            //printContents = document.getElementById(printSection).innerHTML;
            popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
            popupWin.document.open();
            popupWin.document.write(`
          <html>
              <head>
                  <title>Print tab</title>
                  <style>
                    body{
                        direction: rtl;
                    }
                    .no-border>tbody>tr>td{
                      border: none !important;
                      
                    }
                    .printNone{
                      display: none !important;
                      margin-left: 10%;
                    }
                    body
                    {
                        counter-reset: page;
                         margin-left:10%;
                          margin-right: 5%;
                    }
                    p, table, tbody, tr, td{
                        font-size: 14px !important;
                        font-family: "Times New Roman" !important;
                    }
                     /*.innerHTMLStyle p{*/
                            /*margin-top:10px; padding-bottom: 0px;margin-bottom: 0px;font-weight: bold;text-transform: uppercase;font-family: "Times New Roman";*/
                    /*}*/
                     .innerStyle table {
                        width: 50% !important;
                    }
                    
                    .innerStyle p {
                         font-size: 12px;
                        font-family: 'Times New Roman';
                        margin-bottom: 0px !important;
                        margin-top: 10px !important;
                    }
                    .innerStyle p{
                        margin-top:10px;
                        padding-bottom: 0px;
                        margin-bottom: 0px;
                        font-weight: bold;
                        /*text-transform: uppercase;*/
                        font-family: "Times New Roman";
                    }
                    #pageFooter
                    {
                        page-break-before: always;
                        counter-increment: page;
                         margin-bottom: 5%;
                    }
                    /*#pageFooter:after*/
                    /*{*/
                        /*display: block;*/
                        /*text-align: right;*/
                        /*content: "Page " counter(page);*/
                    /*}*/
                    #pageFooter:after {
                        counter-increment: page;
                        content:"Page " counter(page);
                        left: 0; 
                        top: 100%;
                        white-space: nowrap; 
                        z-index: 20;
                        -moz-border-radius: 5px; 
                        -moz-box-shadow: 0px 0px 4px #222;  
                        background-image: -moz-linear-gradient(top, #eeeeee, #cccccc);  
  }
                    #pageFooter.first.page
                    {
                        page-break-before: avoid;
                    }
                    /*.ui-grid-col-6{*/
                     /*display: none !important;*/
                    /*}*/

                  </style>

                  <link rel="stylesheet" href="assets/css/your_style.css">

                  <!-- Latest compiled and minified CSS -->
                  <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css">

                  <!-- jQuery library -->
                  <script src="https://ajax.googleapis.com/ajax/libs/jquery/3.2.1/jquery.min.js"></script>

                  <!-- Latest compiled JavaScript -->
                  <script src="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/js/bootstrap.min.js"></script>

              </head>
              <body onload="window.print();window.close()">${printContentssummary}
              <div id="content">
        <div id="pageFooter">
        </div>
    </div>
              </body>
          </html>`
            );
            popupWin.document.close();
        } else {
            let printContents, popupWin;
            printContents = document.getElementById('printContentssummaryNew').innerHTML;
            popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
            popupWin.document.open();
            popupWin.document.write(`
          <html>
              <head>
                  <title>Discharge Summary</title>
                  <style>
                    .no-border>tbody>tr>td{
                      border: none !important;
                      /*margin-left:10%;*/
                    }
                    .printNone{
                      display: none !important;
                    }
                   body
                    {
                        counter-reset: page;
                          margin-left:10%;
                          margin-right: 5%;
                          
                    }
                   p, table, tbody, tr, td{
                        font-size: 14px !important;
                        font-family: "Times New Roman" !important;
                    }
                    /*.innerHTMLStyle p{*/
                            /*margin-top:10px; padding-bottom: 0px;margin-bottom: 0px;font-weight: bold;text-transform: uppercase;font-family: "Times New Roman";*/
                    /*}*/
                    .innerStyle table {
                        width: 50% !important;
                    }
                    
                    .innerStyle p {
                         font-size: 12px;
                        font-family: 'Times New Roman';
                        margin-bottom: 0px !important;
                        margin-top: 10px !important;
                    }
                    #pageFooter
                    {
                        page-break-before: always;
                        counter-increment: page;
                        margin-bottom: 5%;
                    }
                    #pageFooter:after
                    {
                        display: block;
                        text-align: right;
                        content: "Page " counter(page);
                        const pageCount =0;
                   
                   for(var counter=1; i<=pageCount; counter++){
                   this.counter(page);
                   /*this.counter('page ' + String(counter) + ' of ' + String(pageCount),210-20,297-30,null,null,"right");*/
                   }
                    content: "Page " counter(page);
                    }
                    #pageFooter.first.page
                    {
                        page-break-before: avoid;
                    }
                     /*.ui-grid-col-6{*/
                     /*display: none !important;*/
                    /*}*/
                    @media print{
                        .footer{
                           position:relative;
                           top:-20px;                     
                           height:10px;
                        }
                    }
                  </style>

                  <link rel="stylesheet" href="assets/css/your_style.css">

                  <!-- Latest compiled and minified CSS -->
                  <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css">

                  <!-- jQuery library -->
                  <script src="https://ajax.googleapis.com/ajax/libs/jquery/3.2.1/jquery.min.js"></script>

                  <!-- Latest compiled JavaScript -->
                  <script src="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/js/bootstrap.min.js"></script>

              </head>
              <body onload="window.print();window.close()">${printContents}
              
              <!--<div class="footer">This should be on bottom of page2</div>-->
    
              </body>
          </html>`
            );
            popupWin.document.close();
        }
    }

    resetfilter() {
        $('#dtId').val(0);
        $('#mrno').val('');
        $('#pname').val('');
        $('#ipdno').val('');
        $('#fromdate').val('');
        $('#todate').val('');
        $('#today').val('');
        this.todaylist = false;
    }

    loadUserSubModule() {
        for (let ua of this.userAccess) {
            if (ua.aurActionSubModuleName === 'Discharge List' && ua.aurActionModuleName === 'IPD') {
                for (let bt of ua.actionButton) {
                    if (bt.abName === 'Cancel Discharge') {
                        this.smbCancelDischarge = true;
                    }
                }
            }
        }
    }
}







// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/ipd/trn-dischargelist/trn-dischargelist.component.ts